export const _adr = {
  Root: process.env.REACT_APP_ROOT,
  Landing: { Index: "/landing", Details: "/item" },
  Security: {
    Login: "/login",
  },
  Accounts: {
    Index: "/accounts",
    NewUser: {
      Index: "/newuser",
      Profile: "/profile",
      Address: "/address",
      BankInfo: "/bankinfo",
      Review: "/review",
    },
    Wallet: {
      Index: "/wallet",
    },
    Transactions: {
      Index: "/transactions",
    },
    Withdraw: {
      Index: "/withdraw",
    },
    Order: {
      Index: "/Order",
    },
  },
};
export const _ckey = {
  expiretimeLogin: "_expiretimelogin",
  token: "_authro",
  hashPassword: "_hashPassword",
  expireUTCTime: "_expireUTCTime",
};
